import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidUkIcon,
  IphoneUkIcon,
  GameUkIcon,
  FlutterIcon,
  HealthcareUkIcon,
  ReactUkIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidUkIcon,
    title: "Android Development Consulting",
    description:
      "TekRevol’s Android development consulting takes your project to the next level. Our experienced team of Android app developers in UK provides insightful guidance, leveraging their expertise to navigate the dynamic domain of mobile app development. Partnering with TekRevol means tapping into a wealth of knowledge from one of the top Android app development companies. Our Android development consulting ensures your project is on the right track, aligning with industry best practices and tailored to your business goals.",
  },
  {
    icon: IphoneUkIcon,
    title: "Custom Android App Development",
    description:
      "When it comes to Android app development, TekRevol stands out for its commitment to delivering tailor-made solutions. Our team of dedicated professionals specializes in custom app development, ensuring that your Android app is uniquely crafted to meet your specific requirements. Hire Android app developers from TekRevol to bring your distinct vision to life. We prioritize a practical and hands-on approach, working closely with you to understand your needs and objectives.",
  },
  {
    icon: GameUkIcon,
    title: "UX and UI Design for Android",
    description:
      "At TekRevol, our Android app development services in UK extend beyond functionality to prioritize an intuitive and visually appealing user experience. As one of the leading Android app development companies, we understand the importance of seamless UX and UI design. Our team in the UK is dedicated to crafting interfaces that not only meet user expectations but exceed them. Partner with TekRevol for Android app development that goes beyond coding – we ensure that your app is not just functional but user-friendly and aesthetically pleasing.",
  },
  {
    icon: FlutterIcon,
    title: "Android Web App Development",
    description: (
      <>
        As an established Android app development company in London, TekRevol
        brings a strategic edge to Android web app development. Our focus on
        practical solutions ensures that your Android app seamlessly extends its
        capabilities to the web. In addition to our Android expertise, we offer
        comprehensive{" "}
        <Link to="https://www.tekrevol.com/uk/web-development-company-uk">
          web development services
        </Link>
        , creating dynamic and responsive websites that enhance user engagement
        and drive business growth. Trust TekRevol for expert Android web app
        development services that go beyond your expectations.
      </>
    ),
  },
  {
    icon: HealthcareUkIcon,
    title: "Android App Testing",
    description:
      "As your preferred Android app development company in UK specializing in custom Android app development, TekRevol ensures the reliability and performance of your applications through rigorous Android app testing. Our dedicated team conducts thorough assessments to identify and rectify potential issues, guaranteeing a seamless user experience. With our practical approach to Android app development services, we prioritize the quality assurance phase, ensuring that your custom Android app is robust and ready for deployment.",
  },
  {
    icon: ReactUkIcon,
    title: "App Support and Maintenance with New Features",
    description:
      "TekRevol goes beyond initial development – we offer ongoing app support and maintenance with the integration of new features. When you hire Android app developers from our UK-based team, you ensure that your app remains robust, up-to-date, and continuously meets user expectations. Our proactive approach to Android app development in UK includes regular maintenance to address any issues and enhance your app with fresh features.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              TekRevol’s Game-Changing Android App Development Services in UK
            </h2>
            <p className="impro_para">
              Our game-changing approach to Android application development
              services sets us apart. With a focus on custom Android app
              development services, we bring your unique vision to life. As your
              trusted partner in the UK, we're committed to delivering practical
              and effective Android app development solutions that cater to your
              specific needs. Here are the Android app development services in
              UK that TekRevol offers:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
